import { Component, Input } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'md-roll-over-accounts',
  template: require('./roll-over-accounts.component.html'),
  styles: [require('./roll-over-accounts.component.scss')]
})

export class RollOverAccountsComponent {
  @Input() accountNumber: string;

  constructor(modal: ModalService) {
    this.modal = modal;
  }

  openLeavingAllyModal() {
    this.modal.interstitial('capitalize');
  }

}
